import React from "react";
import { Wallet, Activity, Calculator, ShieldCheck, Layers } from "lucide-react";

const MAP = {
  wallet: Wallet,
  activity: Activity,
  calculator: Calculator,
  shield: ShieldCheck,
};

export function StructureIcon({ name, className, style }) {
  const Icon = MAP[name] || Layers;
  return <Icon className={className} style={style} />;
}
